import React from "react"
import { graphql } from "gatsby"
import { Flex } from "theme-ui"
import CommonTemplate from "templates/common-template"
import Promotions from "components/Homepage/promotions"
import CompanyLogos from "components/company-logos"
import Testimonials from "components/lists/testimonials-list"
import BottomLinks from "components/lists/bottom-link-list"
import PressCard from "components/cards/press-release-card"

// markup
const IndexPage = ({ location, data, pageContext }) => {
    let customJsx = null
    const prefix = process.env.PREFIX_SLUG
    if (
        [`${prefix}-who-we-are`, `${prefix}-why-edunamics`].includes(
            pageContext.slug
        )
    ) {
        customJsx = <Promotions data={data.promotions} />
    } else if (pageContext.slug === `${prefix}-our-companies`) {
        customJsx = <CompanyLogos />
    } else if (pageContext.slug === `${prefix}-testimonials`) {
        const linkList = [
            {
                url: "/about-us/handouts-press-release",
                title: "Handout & Press Release",
            },
            {
                url: "/about-us/testimonials",
                title: "Our Clients Testimonials",
            },
            {
                url: "/about-us/our-companies",
                title: "Our Companies",
            },
        ]
        customJsx = (
            <>
                <Testimonials />
                <BottomLinks links={linkList} />
            </>
        )
    } else if (pageContext.slug === `${prefix}-handouts-press-release`) {
        const documents = data.pageData.content.map((content, index) => {
            let html = null
            if (content.document !== undefined && content.document !== null) {
                html = content.document.map((doc, idx) => (
                    <PressCard
                        key={idx}
                        title={doc.file_title}
                        imageFile={doc.thumbnail}
                        url={doc.file && doc.file.publicURL}
                    />
                ))
            }
            return html
        })
        customJsx = <Flex sx={{ flexWrap: "wrap", justifyContent: "space-around" }}>{documents}</Flex>
    }
    const arrData = {
        location,
        data,
        galleryMinWidth: "40%", //default 0
        customElement: customJsx,
        // breadcrums // allow null
    }
    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query AboutUsQuery($slug: String!) {
        pageData: strapiPage(
            slug: { eq: $slug }
            company: { shortname: { eq: "EDN" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
                publicURL
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Image_Size
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
                Gallery_Image {
                    title
                    media {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                        }
                        publicURL
                    }
                }
                Accordion {
                    content
                    title
                }
                external_script {
                    name
                    script
                }
                document {
                    file_title
                    file {
                        publicURL
                    }
                    thumbnail {
                        childImageSharp {
                            gatsbyImageData(placeholder: BLURRED)
                        }
                    }
                }
            }
        }
        promotions: allStrapiPost(
            sort: { fields: createdAt, order: DESC }
            limit: 3
            filter: {
                Post_Type: { eq: "Promotions" }
                slug: { ne: "dummy-data-do-not-pull" }
            }
        ) {
            edges {
                node {
                    id
                    createdAt
                    title
                    slug
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 300
                                width: 640
                            )
                        }
                    }
                }
            }
        }
    }
`
